import React from 'react'
import { content } from '../../../../config'
import { PushButtonStoreContainer } from './push-button-store.style'

const { BRAND_NAME, APP_ANDROID_LINK, APP_IOS_LINK } = content
const storeIcon = require(`../../../../assets/icons/store/${BRAND_NAME.toLowerCase()}/icon-app.png`)

export const PushButtonStore = () => {
	let APP_LINK = null
	const userAgent = navigator.userAgent || navigator.vendor || window.opera

	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		APP_LINK = APP_IOS_LINK
	} else {
		APP_LINK = APP_ANDROID_LINK
	}

	return (
		<PushButtonStoreContainer>
			<img src={storeIcon} />
			<p>
				<span>Vantagens exclusivas no App</span>
				<span>Abrir o app do {BRAND_NAME}</span>
			</p>
			<a href={APP_LINK} target="_blank">
				ABRIR
			</a>
		</PushButtonStoreContainer>
	)
}
